import { Button, makeStyles, Typography, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNotification } from '../../hooks';
import Modal from '../common/modal';
import { completeCandidateFromPdf } from '../../api/candidate';
import { useHistory } from 'react-router-dom';
// import InterviewForm from '../forms/interview';

const useStyles = makeStyles({
    root: {
        width: '55.3125rem',
        '@media (max-width:420px)': {
            padding: 24,
        },
    },
    container: {
      paddingBottom: '2rem',
    },
    title: {
        fontSize: '2.5rem',
        lineHeight: '2.9375rem',
        marginBottom: '.8125rem',
        '@media (max-width:420px)': {
            fontSize: '1.5rem',
            lineHeight: '1.9375rem',
            fontWeight: '700',
        },
    },
    body: {
        fontSize: '1.25rem',
        lineHeight: '150%',
        marginBottom: '2.0625rem',
        '@media (max-width:420px)': {
            fontSize: '1rem',
            lineHeight: '120%',
            marginBottom: '1.0625rem',
        },
    },
    button: {
        marginTop: '2.875rem',
        '@media (max-width:420px)': {
            marginTop: '1.875rem',
        },
    },
});

const PdfDataExtractor = ({setReload, reload}) => {
    const history = useHistory();
    const { hash } = useParams();
    const classes = useStyles();
    const notifications = useNotification();
    const [open, setOpen] = useState(false);
    const languages = ['EN','SP']
    var selectedlanguage = 'EN';
    var pdfFileBase64 = '';
    const isEditing = true;

    function handleSubmit(event) {
        let data = { pdfBase64: pdfFileBase64, language: selectedlanguage }; 
        // setDisabled(true);
        completeCandidateFromPdf(hash, data)
            .ready()
            .then((res) => {
                if (res.success) {
                    notifications.success({
                        message: 'Candidate profile updated sucessfully',
                    });
                    setOpen(false);
                    setReload(!reload);
                    //history.go(0);
                    // hacer refresh
                } else
                    notifications.error({
                        message:
                            'Your request could not be processed at this time, please retry later.\nThanks and sorry for the inconvenience.',
                    });
            })
            .catch((err) => {
                notifications.error({
                    message:
                        'Your request could not be processed at this time, please retry later.\nThanks and sorry for the inconvenience.',
                });
            })
            .finally(() => {
                //setDisabled(false);
            });
    }

    function handleFileUpload(event) {
        let selectedFile = event.target.files;
        let fileName = "";
        //Check File is not Empty
        if (selectedFile.length > 0) {
            // Select the very first file from list
            let fileToLoad = selectedFile[0];
            fileName = fileToLoad.name;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                pdfFileBase64 = fileLoadedEvent.target.result;
            };
            // Convert data to base64
            fileReader.readAsDataURL(fileToLoad);
        }
    };

    return (
        <div className={classes.container} >
            <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
                Upload a Linkedin PDF Profile
            </Button>
            <Modal
                className={classes.root}
                open={open}
                disableBackdropClick={false}
                onClose={() => setOpen(false)}
            >
                <div>
                    <Typography className={classes.subtitle} variant="subtitle1" align="left">
                        Please upload the exported linkedin profile
                    </Typography>
                    <input type='file' onChange={handleFileUpload} accept="application/pdf"></input>

                    <Typography className={classes.subtitle} variant="subtitle1" align="left">
                        Language
                    </Typography>

                    <RadioGroup
                        row aria-label="language" name="language"
                        defaultValue={languages[0]}
                        onChange={(e,value) => {
                            selectedlanguage = languages.find(x => x === value);
                        }}
                    >
                        {languages.map((item) => (
                            <FormControlLabel value={item} control={<Radio color="primary" />} label={item} />
                        ))}
                        
                    </RadioGroup>

                    <Button variant="contained" style={{ marginTop: '1em', marginRight: '2em' }} color="primary" onClick={handleSubmit}>
                        SAVE AND CONTINUE
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default PdfDataExtractor;
